import {Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {modalCRUDService} from "../services/modalCRUDService";
import {routesFormCrudModal} from "../data/RoutesFormCrud";
import {isEmpty} from "../util/is";
import { useHistory } from "react-router-dom";

const defaultId = 'defaultModalCRUD';

const RenderForm = ({props, type}) => {

    const { isEditing, isAddMode, properties } = props;
    const Component = routesFormCrudModal[type];

    if(isEmpty(Component)){
      return (
        <div>
          No existe el formulario, debes crearlo en views/formularios y asociarlos en data/RoutesFormCrud
        </div>
      )
    }

    return (<Component isEditing={isEditing} isAddMode={isAddMode} properties={properties} />)

}

const ModalCRUD = ({id = defaultId}) => {

    let history = useHistory();

    const [modalCRUD, setModalCRUD] = useState(null);

    useEffect(() => {

        const subscription = modalCRUDService.onModalCRUD(id)
            .subscribe(modal=> {
                if (!modal.type) {
                    setModalCRUD(null);
                } else {
                    setModalCRUD(modal);
                }
        });

        const historyUnlisten = history.listen(() => {
            modalCRUDService.clear(id);
        });

        return () => {
            subscription.unsubscribe();
            historyUnlisten();
        };

    }, []);

    const removeModalCRUD = () => {
        setModalCRUD(null);
    }

    if (!modalCRUD) return null;

    return (
        <Modal
        id={modalCRUD.id}
        size={modalCRUD.size}
        show={true}
        onHide={() => removeModalCRUD()}
        backdrop="static"
        aria-labelledby={modalCRUD.id}
        className="modalCRUD p-0 m-0"
        centered
        >
        <Modal.Header className="headerModal" closeButton>
            <a className="icon-container">
                <div/>
                {modalCRUD.isAddMode?
                    <i className="fas fa-plus"/>
                    :
                 modalCRUD.isEditable?
                    <i className="fas fa-pen"/>
                    :
                    <i className={modalCRUD.icon}/>
                }
            </a>
            <Modal.Title className="mb-0">
                {modalCRUD.title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className={!modalCRUD.dense?'p-0':''}>

            <RenderForm type={modalCRUD.type} props={{
              isEditing: modalCRUD.isEditable,
              isAddMode: modalCRUD.isAddMode,
              properties: {...modalCRUD.props, idModal: modalCRUD.id}
            }} />

        </Modal.Body>
    </Modal>)


}

export { ModalCRUD };
